const SplitTestConstants = {
  ZRM_CONCISE_MODULAR_LISTING: 'zrm-concise-modular-listing',
} as const;

export default SplitTestConstants;
